import moment from 'moment';

export const processes = [
  {
    date: moment(),
    processes_date:moment(),
    shift: null,
    mc_no: null,
    part_id: null,
    rotor_size: null,
    batch_number: null,
    operator: null,
    operator_2: null,
    time_start: null,
    time_stop: null,
    shot: null,
    no_of_cavity: null,
    total_qty: null,
    ok_qty: null,
    rej_qty: null,
    verified_sign: null,
    remarks: null,
    prod_qty:null,
    reasons_for_rej: Array.from({ length: 21 }, () => ({
      reason: '',
      rej_qty: 0,
    })),
  },
];

export const initialState = {
  isSubmitted: false,
  is_admin_request_no: null,
  is_admin_request: null,
  report_prepared_by: null,
  report_approved_by: null,
  annual_month: '',
  processes: Array.from({ length: 1 }, () => ({ ...processes[0] })),
};
